<template>
  <div>
    <div v-if="popupShow" class="privacy-popup">
      <div v-if="MIPopupShow" class="mi-popup">
        <div class="policy-detail mi-detail">
          <div class="detail-title">个人信息保护政策</div>
          <div class="detail-content" v-html="policyDetail">
          </div>
        </div>
        <div class="policy-action">
          <div class="select">
            <label for="c1">
              <input id="c1" v-model="checkedMISelects" name="select" type="checkbox" value="1">
              <p>本人已阅读并同意<u class="u-mi">《个人信息保护政策》</u></p>
            </label>
            <label for="c2">
              <input id="c2" v-model="checkedMISelects" name="select" type="checkbox" value="2">
              <p>本人已阅读并同意米其林按照<u class="u-mi">《个人信息保护政策》</u>的约定处理我的敏感个人信息</p>
            </label>
            <label for="c3">
              <input id="c3" v-model="checkedMISelects" name="select" type="checkbox" value="3">
              <p>本人已阅读并同意米其林按照<u class="u-mi">《个人信息保护政策》</u>所明确的境外接收方出境我的个人信息</p>
            </label>
          </div>
          <div class="commom-btns m-submit-btns">
            <button class="btn-item agree" :disabled="checkedMISelects.length<3" @click="agreeMIPolicy()">同意</button>
            <button class="btn-item disagree" @click="disagreeMIPolicy()">不同意</button>
          </div>
        </div>
      </div>
      <div v-if="TPPopupShow" class="tplus-popup">
        <div class="policy-detail tp-detail">
          <div class="detail-title">个人信息保护政策</div>
          <div class="detail-content" v-html="policyDetail">
          </div>
        </div>
        <div class="policy-action">
          <div class="select">
            <label for="t1">
              <input id="t1" v-model="checkedTPlusSelects" name="select" type="checkbox" value="1">
              <p>本人已阅读并同意<u class="u-tp">《个人信息保护政策》</u></p>
            </label>
            <label for="t2">
              <input id="t2" v-model="checkedTPlusSelects" name="select" type="checkbox" value="2">
              <p>本人已阅读并同意驰加按照<u class="u-tp">《个人信息保护政策》</u>的约定处理我的敏感个人信息</p>
            </label>
            <label for="t3">
              <input id="t3" v-model="checkedTPlusSelects" name="select" type="checkbox" value="3">
              <p>本人已阅读并同意驰加按照<u class="u-tp">《个人信息保护政策》</u>所明确的境外接收方出境我的个人信息</p>
            </label>
          </div>
          <div class="commom-btns t-submit-btns">
            <button class="btn-item agree" :disabled="checkedTPlusSelects.length<3" @click="agreeTPlusPolicy()">同意</button>
            <button class="btn-item disagree" @click="disagreeTPlusPolicy()">不同意</button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="wrapperShow" class="popup-wrapper" @click="wrapperClick()"></div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPopup',
  data() {
    return {
      checkedMISelects: [],
      checkedTPlusSelects: [],
      popupShow: true,
      MIPopupShow: false,
      TPPopupShow: false,
      policyDetail: '',
      wrapperShow: true,
      currAgreementIdx: 0
    }
  },
  computed: {
    agreements() {
      return this.$store.getters.agreements
    }
  },
  watch: {
    wrapperShow(n, o) {
      const app = document.getElementById('app')
      const appMain = document.getElementsByClassName('app-main')[0]
      if (n === true) {
        app.style.overflow = 'hidden'
        appMain.style.overflow = 'unset'
      } else {
        app.style.overflow = 'auto'
        appMain.style.overflow = 'hidden'
      }
    }
  },
  mounted() {
    if (!this.agreements || !this.agreements.length || !this.agreements[0].agreementPk) {
      this.checkAgreements()
      return
    }
    this.initPopup()
  },
  methods: {
    initPopup() {
      if (this.agreements.length > 1) {
        this.MIPopupShow = true
        this.policyDetail = this.agreements[0].content
      } else if (this.agreements.length > 0) {
        switch (this.agreements[0].category) {
          case 'TP':
            this.TPPopupShow = true
            this.policyDetail = this.agreements[0].content
            break
          case 'NT':
            this.MIPopupShow = true
            this.policyDetail = this.agreements[0].content
            break
        }
      }
    },
    checkAgreements() {
      const bizType = ''
      this.$api.login.checkToken({ bizType }).then(res => {
        if (res.success && res.data.agreements) {
          this.$store.dispatch('user/SET_AGREEMENTS', res.data.agreements).then(() => {
            this.initPopup()
          })
        }
      })
    },
    open() {
      this.popupShow = true
      this.wrapperShow = true
    },
    close() {
      this.popupShow = false
      this.wrapperShow = false
      this.$store.dispatch('user/SET_AGREEMENTS', [])
    },
    // 非驰加
    agreeMIPolicy() {
      const agreementPk = this.agreements[0].agreementPk
      this.$api.login.signAgreement(agreementPk).then(res => {
        if (res.success) {
          this.MIPopupShow = false
          this.popupShow = false
          const tempAgreements = res.data.agreements
          this.$store.dispatch('user/SET_AGREEMENTS', tempAgreements)
          if (tempAgreements.length > 0) {
            this.policyDetail = tempAgreements[0].content
            setTimeout(() => {
              this.popupShow = true
              this.TPPopupShow = true
            }, 300)
          } else {
            this.close()
          }
        }
      }).catch(() => {
      })
    },
    disagreeMIPolicy() {
      this.close()
      this.checkedMISelects = []
    },
    // 驰加
    agreeTPlusPolicy() {
      const agreementPk = this.agreements[0].agreementPk
      this.$api.login.signAgreement(agreementPk).then(res => {
        if (res.success) {
          this.TPPopupShow = false
          this.popupShow = false
          this.$store.dispatch('user/SET_AGREEMENTS', [])
          this.close()
        }
      }).catch(() => {
      })
    },
    disagreeTPlusPolicy() {
      this.close()
      this.checkedTPlusSelects = []
    },
    wrapperClick() {
      !this.popupShow ? this.popupShow = true : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-popup {
  position: fixed;
  z-index: 100;
  width: 1000px;
  color: #000000;
  border-radius: 4px;
  background-color: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  input {
    margin-right: 8px;
    margin-top: 4px;
    box-shadow: 1px 1px 1px #000000;
  }
  label {
    display: flex;
    align-items: flex-start;
  }
  input::before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-top: 1px solid #000000;
    border-left: 1px solid #000000;
    border-bottom: 2px solid #000000;
    border-right: 2px solid #000000;
  }

  .title {
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    margin: 40px 0 30px 0;
  }
  .subtitle {
    font-size: 18px;
    text-align: right;
    padding-right: 10px;
  }
  .policy-action {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
    background-color: #f7f7f7;
    border-radius: 0 0 4px 4px;
  }
  .select {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    .u-mi {
      font-weight: 600;
      color: #548dd4;
    }
    .u-tp {
      font-weight: 600;
      color: #1a9141;
    }
  }
  .commom-btns {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    .btn-item {
      width: 100px;
      height: 40px;
      font-size: 16px;
      border-radius: 6px;
      border: none;
    }
    .agree:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    .disagree {
      color: #8f8f8f;
    }
  }
  .m-submit-btns {
    .agree {
      background-color: #25519b;
      color: #ffffff;
    }
  }
  .t-submit-btns {
    .agree {
      background-color: #094;
      color: #ffffff;
    }
  }
  .el-icon-back {
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 24px;
  }
  .policy-detail {
    margin: 10px 6px;
    padding: 0px 20px 0 30px;
    height: 316px;
    overflow-y: auto;
    .detail-title {
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: calc(100% - 62px);
      background-color: #fff;
      top: 0;
      font-weight: bold;
    }
    .detail-content {
      margin-top: 30px;
    }
  }
}
.popup-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
// 复选框
.mi-popup {
  input[type='checkbox']:checked::before {
    display: block;
    content: '\2714';
    color: #fff;
    font-size: 10px;
    line-height: 10px;
    background-color: #548dd4;
  }
}
.tplus-popup {
  input[type='checkbox']:checked::before {
    display: block;
    content: '\2714';
    color: #fff;
    font-size: 10px;
    line-height: 10px;
    background-color: #1a9141;
  }
}
// 滚动条
.policy-detail::-webkit-scrollbar {
  width: 3px;
  height: 8px;
}
.policy-detail::-webkit-scrollbar-track {
  border-radius: 2px;
}
.tp-detail::-webkit-scrollbar-thumb {
  background: #1a9141;
  border-radius: 8px;
}
.tp-detail::-webkit-scrollbar-thumb:hover {
  background: #1a9141;
}
.mi-detail::-webkit-scrollbar-thumb {
  background: #548dd4;
  border-radius: 8px;
}
.mi-detail::-webkit-scrollbar-thumb:hover {
  background: #548dd4;
}
/deep/ ol,
ul,
li {
  list-style-type: decimal !important;
}
</style>
